<template>
  <div class="m750" ref="currentMain">
    <!-- <Boxingheader :pageTitle="'欧洲杯竞猜'"></Boxingheader> -->
    <PublicHeader
      letter="N"
      :code="3"
      :value1="id"
      :title="title"
      :imgurl="imgUrl"
    >
      <div class="openApp">打开APP</div>
    </PublicHeader>
    <div class="EuropeanCup">
      <div class="banner">
        <div class="rule-btn" @click="lookMore('rule', 0)"></div>
      </div>
      <div class="content">
        <div class="select-tab">
          <img
            class="tabsbg"
            src="https://images.zhibo.tv/2021/0607/icon_topbg_l.png"
          />
          <div
            id="newtabs"
            ref="newtabs"
            class="tabs"
            :class="{ tabsnew: guesslist.length < 3 }"
          >
            <div
              @click="selectDay(index)"
              :class="{ tabitem_select: isactive == index }"
              class="tabitem"
              v-for="(item, index) in guesslist"
              :key="index"
              :id="'a' + index"
              ref="tabitem"
            >
              {{ item.name }}
            </div>
          </div>
          <img
            class="tabsbg"
            src="https://images.zhibo.tv/2021/0607/icon_topbg_r.png"
          />
        </div>
        <div class="answer">
          <div class="answer_title" v-if="currentGuess">
            {{ currentGuess.guess_content }}
          </div>
          <!-- 答题已经结束 正确的选项显示图片，用户答过的选项显示选中样式 -->
          <div class="answer_options" v-if="currentGuess.is_start == 1">
            <div
              :class="{
                answerSelect:
                  myGuess &&
                  myGuess.filter((item) => item.guess_id == currentGuess.id)
                    .length > 0 &&
                  myGuess.filter((item) => item.guess_id == currentGuess.id)[0]
                    .guess_option == item.answer,
              }"
              class="answer_option"
              v-for="(item, index) in currentGuess.teams"
              :key="index"
            >
              <!-- is_true==1 正确 -->
              <div class="option">
                <img
                  v-if="item.is_true == 1"
                  src="https://images.zhibo.tv/2021/0713/answer_correct.png"
                  alt=""
                />
                {{ item.answer }}
              </div>
            </div>
          </div>
          <!-- 答题没有结束 已经参与过 -->
          <div class="answer_options" v-else-if="currentGuess.is_guess == 1">
            <div
              :class="{
                answerSelect:
                  myGuess &&
                  myGuess.filter((item) => item.guess_id == currentGuess.id)
                    .length > 0 &&
                  myGuess.filter((item) => item.guess_id == currentGuess.id)[0]
                    .guess_option == item.answer,
              }"
              class="answer_option"
              v-for="(item, index) in currentGuess.teams"
              :key="index"
            >
              <div class="optin">{{ item.answer }}</div>
            </div>
          </div>
          <!-- 答题没有结束 没有参与过 -->
          <div class="answer_options" v-else>
            <div
              @click="selectAnswer(index, item.id)"
              :class="{ answerSelect: currentAnswer == index }"
              class="answer_option"
              v-for="(item, index) in currentGuess.teams"
              :key="index"
            >
              <div class="optin">{{ item.answer }}</div>
            </div>
          </div>
          <!-- 已经竞猜过 -->
          <img
            v-if="
              overGuessId.indexOf(currentGuess.id) != -1 ||
              currentGuess.is_guess == 1
            "
            class="answer_submit"
            src="https://images.zhibo.tv/2021/0713/answer_btn1over.png"
            alt=""
          />
          <!-- !=1 没有结束 -->
          <img
            v-else-if="currentGuess.is_start != 1"
            @click="answerSubmit"
            class="answer_submit"
            src="https://images.zhibo.tv/2021/0713/answer_btn1.png"
            alt=""
          />
          <!-- 结束但是没参与 -->
          <img
            v-else
            class="answer_submit"
            src="https://images.zhibo.tv/2021/0713/answer_btn1no.png"
            alt=""
          />
        </div>
       
       
        <!-- 分享有奖 -->
        <!-- 助力没结束 -->
        <div class="module share">
          <h3><div class="shareimg">分享助力</div></h3>
          <div class="share-module">
            <div>
              <figure>
                <img src="https://images.zhibo.tv/2021/0713/goods.png" />
              </figure>
              <p>
                每成功邀请一位好友助力，多一份瓜分<br />
                名额（每日助力上限为5人）
              </p>
            </div>
            <div class="sharestats">
              <!-- <p>助力人数达到5，将额外获赠3张竞猜券</p> -->
              <div>
                <span>当前助力人数:{{ powerNum }}</span>
                <div>
                  <p>
                    <i
                      v-for="(item, index) in powerList.slice(0, 5)"
                      :key="index"
                    >
                      <img
                        v-if="item.img"
                        :src="item.img"
                        alt=""
                        class="powerimg"
                      />
                      <img
                        v-else
                        src="https://t100-file.zhibo.tv/images/video_user.png"
                        alt=""
                        class="powerimg"
                      />
                    </i>
                  </p>
                </div>
              </div>
              <div
                class="btn share-btn"
                v-if="currentGuess.is_start != 1"
                @click="toShare"
              ></div>
            </div>
          </div>
        </div>
        <!-- 我的竞猜 v-if="myGuess.length > 0"-->
        <div class="module mybet">
          <h3><div class="shareimg">我的竞猜</div></h3>
          <div class="mybetlog">
            <p class="caption">
              <span class="time">竞猜时间</span>
              <span class="score">赢得播币</span>
              <span>详情</span>
            </p>
            <template v-if="myGuess.length > 0">
              <p v-for="(item, index) in myGuess" :key="index">
                <span class="time">{{ handleCTime(item.create_time) }}</span>
                <span class="score" v-if="item.status == 1"
                  >{{ item.points }}
                </span>
                <span class="score" v-else>等待开奖</span>
                <span @click="lookMore('betInfo', 3, 0, item)">查看</span>
              </p>
            </template>
            <div class="noData" v-else>- 暂无数据 -</div>
            <!-- <div class="more" @click="lookMore('betLog', 1)">
              <span>查看全部 ></span>
            </div> -->
          </div>
        </div>
        <div class="logo">
          <img
            class="logoimg"
            src="https://images.zhibo.tv/2021/0713/logo.png"
            alt=""
          />
        </div>
        <!-- 弹层 -->
        <div class="mask" v-if="maskShow">
          <div class="mask-layer">
            <div class="mask-content">
              <div class="close" @click="closeBtn"></div>

              <div class="mask-title">{{ answer_message }}</div>
              <!-- 规则 -->
              <div class="rule" v-if="rule" v-html="rules">
                <h3>
                  请您仔细阅读《用户协议》。我们根据国家最新法规要求，更新了《用户协议》，特此向您说明如下
                </h3>
                <p>
                  在使用中国体育相关功能或服务，我们会收集、使用您的必要信息，并与第三方数据公司合作为您提供一个更好的服务
                </p>
                <h4>小标题</h4>
              </div>
              <!-- 竞猜详情 -->
              <div class="betInfo" v-if="betInfo">
                <p>
                  竞猜主题：
                  <span>{{ betitem.guess_content }}</span>
                </p>
                <!-- <p>投入播币：<span>{{parseInt(parseInt(betitem.cup_num*100)+parseInt(betitem.use_points))}}</span></p> -->
                <p>
                  获得播币：
                  <span>{{ betitem.points }}</span>
                </p>
                <p>
                  竞猜答案：
                  <span>{{ betitem.guess_option }}</span>
                </p>
                <!-- <p>竞猜队伍：<span>{{ betitem.teamsList.join(".")}}</span></p> -->
              </div>
              <!-- 我的竞猜 -->
              <!-- <div class="betLog" v-if="betLog">
                <div class="caption">
                  <span class="time">竞猜时间</span>
                  <span class="num">赢得播币</span>
                  <span>详情</span>
                </div>
                <ul v-if="myGuess.length">
                  <li v-for="(item, index) in myGuess" :key="index">
                    <span class="time"
                      >{{ handleCTime(item.create_time) }}
                    </span>
                    <span class="num" v-if="item.status == 1"
                      >{{ item.points }}
                    </span>
                    <span class="num" v-else>等待开奖</span>
                    <span @click="lookMore('betInfo', 3, 1, item)">查看</span>
                  </li>
                </ul>
                <ul v-else>
                  <div class="noData">- 暂无数据 -</div>
                </ul>
              </div> -->
              <!-- 竞猜排名 -->
              <div class="topBet" v-if="topBet">
                <div class="caption">
                  <span class="top">名次</span>
                  <span class="name">用户名</span>
                  <span>累计赢得播币</span>
                </div>
                <ul v-if="topList.length">
                  <li v-for="(item, index) in topList" :key="index">
                    <span class="top">No.{{ item.rank }}</span>
                    <span class="name">{{ item.uName }}</span>
                    <span>{{ item.allPoints }}</span>
                  </li>
                </ul>
                <ul v-else>
                  <div class="noData">- 暂无数据 -</div>
                </ul>
              </div>
              <div class="btn close-btn" @click="closeBtn"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="share-box" v-if="isHelp">
        <div class="share-user-info">
          <div class="user-info">
            <div>
              <div class="user-head"><img :src="userHeadImg" /></div>
              <div class="user-name">{{ userName }}</div>
              <div class="share-text">
                <img
                  src="https://images.zhibo.tv/2021/0607/icon_sup.png"
                  class="sup"
                />
                <p class="p1">我正在中国体育APP参加</p>
                <img
                  src="https://images.zhibo.tv/2021/0713/icon_text.png"
                  class="mid"
                />
                <p class="p2">离大奖还差一点，快来帮我点一下吧！</p>
                <img
                  src="https://images.zhibo.tv/2021/0607/icon_sub.png"
                  class="sub"
                />
              </div>
            </div>
            <div class="user-close" @click="closeHelp"></div>
            <div class="help-btn" @click="join" v-if="!isjoin">帮Ta助力</div>
            <div class="help-btn done" v-else @click="closeHelp">
              {{ joinMessage }}
            </div>
            <div class="user-close2" @click="closeHelp">
              <img
                src="https://images.zhibo.tv/2021/0621/userClose.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <!-- <div class="user-close2">
            <img src="https://images.zhibo.tv/2021/0621/userClose.png" alt="">
          </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import ClipboardJS from "clipboard";
import PublicHeader from "@/components/PublicHeader";
import axios from "axios";
export default {
  components: {
    PublicHeader,
  },
  data() {
    return {
      imgUrl: "",
      title: "",
      id: "",
      isHelp: true,
      stab: 0,
      message: "请选择8强队伍后提交",
      // message2: "请选择8支队伍",
      // teamList: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      // tindexList: [[], [], []],
      // number: 1, //输入的竞猜券
      token: "",
      maskShow: false,
      rule: false,
      topBet: false,
      betLog: false,
      betInfo: false,
      // messageList: ["活动说明", "我的竞猜", "竞猜排名", "竞猜详情"],
      // cupNum: "", //竞猜投入的已有的竞猜券
      // points: "", // 竞猜实际支付的播币
      configId: "", //竞猜ID
      // teamIds: "", //用户选择的球队ID串，用英文逗号分隔
      // teamTime: [[], [], []],
      todayTime: 0,
      endTime: [],
      // status: [], //0 未开始，1进行中，2已结束
      // qnumber: 0, //竞猜券数量
      // bnumber: 12000, //播币
      // topList: [], //竞猜排行
      myGuess: [],
      powerList: [], // 助力用户信息
      powerNum: 0,
      power: "",
      gain: "",
      timer: "",
      newitemId: "",
      startY: 0,
      endY: 0,
      // 题目列表
      guesslist: [],
      // 题目高亮 选择哪个题目
      isactive: 0,
      // 当前竞猜题目
      currentGuess: {},
      // 选择选项的id
      isanswer: [],
      // 当前题目选中的选项
      currentAnswer: -1,
      // 竞猜题目id
      guessId: "",
      // 竞猜选项id
      optionId: "",
      userHeadImg: "",
      userName: "",
      isjoin: false,
      overGuessId: [],
    };
  },
  created() {
    this.token = this.$cookies.get("token");
    window.console.log(this.token);

    this.power = this.$cookies.get("roomNum"); //	助力人id
    window.console.log(this.power);
    this.configId = this.$route.query.configId; //竞猜id
    this.gain = this.$route.query.gain; // 被助力人id
    if (this.gain) {
      // 获取被助力人头像昵称
      this.getInfo();
    }
    this.getwxShareInfo();
    if (this.token === "" || this.token === null || this.token === undefined) {
      window.console.log(this.token);
      // this.isjoin = false
    } else {
      if (this.power == this.gain) {
        this.isjoin = true;
        this.joinMessage = "不能为自己助力";
        window.console.log(this.joinMessage);
      } else {
        //判断是否助力过
        this.getOlympicGuessCheckHelp();
      }
    }
    this.getOlympicGuess();
  },
  methods: {
    async getOlympicGuessCheckHelp() {
      let params = {
        guess_id: this.configId,
        help_user_room: this.power,
        user_room: this.gain,
      };
      let res = await this.$api.getOlympicGuessCheckHelp(params);
      window.console.log(res.data.control.status);
      if (res.data.control.status == "404") {
        // 1已助力，0未助力
        this.isjoin = true;
        this.joinMessage = "已助力";
        window.console.log(res.data.control.status);
      } else {
        this.isjoin = false;
        this.joinMessage = "已助力";
      }
    },
    //关闭助力弹框
    closeHelp() {
      this.isHelp = false;
    },
    //参加
    join() {
      if (
        this.token === "" ||
        this.token === null ||
        this.token === undefined
      ) {
        // window.console.log('没登陆')
        this.$router.push({
          name: "login",
          query: {
            path: "shareoguess",
            configId: this.configId,
            gain: this.gain,
          },
        });
      } else {
        // window.console.log('登录')
        this.getGuessShare();
        // Toast('助力成功')
        // this.message = '已助力'
      }
    },
    async getGuessShare() {
      let params = {
        guess_id: this.configId,
        help_user_room: this.power,
        user_room: this.gain,
      };
      let res = await this.$api.getOlympicGuessHelp(params);
      window.console.log(res);
      if (res.data.control.status == "200") {
        // Toast('助力成功')
        // this.message = '已助力'
        this.joinMessage = "已助力";
        this.isjoin = true;
        // this.isHelp = false;
      } else if (res.data.control.status == "405") {
        // this.isjoin = true
        // this.joinMessage = res.data.control.message
        Toast("分享人未参与答题，暂不能助力");
        setTimeout(() => {
          this.isHelp = false;
        }, 3000);
      } else if (res.data.control.status == "409") {
        Toast(res.data.control.message);
        setTimeout(() => {
          this.isHelp = false;
        }, 3000);
      }
    },
    // 获取被助力人头像
    async getInfo() {
      const params = {
        roomNum: this.gain,
      };
      const res = await this.$api.getShareUserInfo(params);
      if (res.data.control.status === 200) {
        this.userName = res.data.data.userName;
        this.userHeadImg = res.data.data.userHeadImg;
      }
    },
    // 选择题目
    selectDay(index) {
      if (this.guesslist[index].is_start == 2) {
        Toast("未开始");
      } else {
        this.isactive = index;
        this.currentAnswer = this.isanswer[this.isactive];
        this.currentGuess = this.guesslist[index];
        if (this.token) {
          // 如果用户登录了，则点击换题目，助力人也要换
          this.getOlympicShare();
        }
      }
    },
    // 选择选项
    selectAnswer(index, id) {
      // 选项id
      this.optionId = id;
      this.isanswer[this.isactive] = index;
      this.currentAnswer = index;
      window.console.log(index, this.isanswer[0] == index);
      // thi
    },
    zero(value) {
      if (value < 10) {
        return "0" + value;
      }
      return value;
    },
    // 处理时间 竞猜开始
    handleCTime(time) {
      var newtime = time.replace(/-/g, "/");
      window.console.log(newtime);
      var myDate = new Date(newtime);
      window.console.log(newtime);

      var year = myDate.getFullYear();
      var month = this.zero(myDate.getMonth() + 1);
      var day = this.zero(myDate.getDate());

      var hour = this.zero(myDate.getHours());
      var minite = this.zero(myDate.getMinutes());
      // var second = this.zero(myDate.getSeconds());
      return year + "." + month + "." + day + " " + hour + ":" + minite;
    },
    gotodown() {
      this.clipboard();
    },
    // 处理微信二次分享
    async getwxShareInfo() {
      const params = {
        url: location.href,
        mp: 1,
      };
      const res = await this.$api.getWXshare(params);
      this.appid = res.data.data.appid;
      this.timestamp = res.data.data.timestamp;
      this.nonceStr = res.data.data.nonceStr;
      this.ticket = res.data.data.ticket;
      this.url = res.data.data.url;
      // if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      // this.signature = decodeURIComponent(res.data.data.sign)
      // } else {
      this.signature = res.data.data.sign;
      // }
      this.title = "参与奥运竞猜 每日瓜分10万播币";
      this.imgurl = "https://images.zhibo.tv/2021/0713/guessshare.png";
      this.desc = "参与奥运竞猜 每日瓜分10万播币";

      let wx = {};
      const that = this;
      if (process.browser) {
        wx = require("weixin-js-sdk");

        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: this.appid, // 必填，公众号的唯一标识
          timestamp: this.timestamp, // 必填，生成签名的时间戳
          nonceStr: this.nonceStr, // 必填，生成签名的随机串
          signature: this.signature, // 必填，签名，见附录1
          ticket: this.ticket,
          jsApiList: [
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
            "onMenuShareQQ",
            "onMenuShareWeibo",
            "onMenuShareQZone",
          ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.onMenuShareTimeline({
            // 分享到朋友圈
            title: that.title, // 分享标题
            link: that.url, // 分享链接
            imgUrl: that.imgurl, // 分享图标
          });

          // 分享给朋友
          wx.onMenuShareAppMessage({
            title: that.title,
            desc: that.desc,
            link: that.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: that.imgurl,
            // success () {
            //   // 用户确认分享后执行的回调函数
            //   alert(1, that.title)
            //   alert(2, that.url)
            //   alert(3, that.imgurl)
            // },
            // cancel () {
            //   // 用户取消分享后执行的回调函数
            //   alert('分享给朋友失败')
            // }
          });
          wx.onMenuShareQQ({
            // 分享到QQ
            title: that.title, // 分享标题
            desc: that.desc, // 分享描述
            link: that.url, // 分享链接
            imgUrl: that.imgurl, // 分享图标
            // success () {
            //   // 用户确认分享后执行的回调函数
            //   alert('分享给QQ成功')
            // },
            // cancel () {
            //   // 用户取消分享后执行的回调函数
            //   alert('分享给QQ失败')
            // }
          });
          wx.onMenuShareWeibo({
            // 分享到腾讯微博
            title: that.title, // 分享标题
            desc: that.desc, // 分享描述
            link: that.url, // 分享链接
            imgUrl: that.imgurl, // 分享图标
            // success () {
            //   // 用户确认分享后执行的回调函数
            //   alert('分享到腾讯微博成功')
            // },
            // cancel () {
            //   // 用户取消分享后执行的回调函数
            //   alert('分享到腾讯微博失败')
            // }
          });
          wx.onMenuShareQZone({
            // 分享到QQ空间
            title: that.title, // 分享标题
            desc: that.desc, // 分享描述
            link: that.url, // 分享链接
            imgUrl: that.imgurl, // 分享图标
            // success () {
            //   // 用户确认分享后执行的回调函数
            //   alert('分享到QQ空间成功')
            // },
            // cancel () {
            //   // 用户取消分享后执行的回调函数
            //   alert('分享到QQ空间失败')
            // }
          });
        });
      }
    },
    clipboard() {
      const that = this;
      const clipboard = new ClipboardJS(".openApp", {
        text() {
          return `${that.letter}:${that.value1}:${that.title}`;
        },
      });
      window.console.log(`${that.letter}:${that.value1}:${that.title}`);
      // window.console.log(`${that.letter}:${that.value1}:${that.title}`)
      clipboard.on("success", function (e) {
        // alert('success')
        window.console.info("Action:", e.action);
        window.console.log("Text:", e.text);
        // alert(e.text)
        window.console.info("Trigger:", e.trigger);
        e.clearSelection();
      });

      clipboard.on("error", function (e) {
        alert("error");
        window.console.log("Action:", e.action);
        window.console.log("Trigger:", e.trigger);
        window.console.log("Text:", e.text);
        alert(e.text);
      });
      window.console.log(clipboard);
      setTimeout(() => {
        this.gotoApp();
      }, 1000);
    },
    gotoApp() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        if (this.$route.name === "atlas-id") {
          location.href = `zhibotv://www.zhibo.tv:80/ios?json={"code":"${this.code}","value1":${this.value1},"value2":"${this.title}","from":"zhibotv"}`;
        } else {
          location.href = `zhibotv://www.zhibo.tv:80/ios?json={"code":"${this.code}","value1":${this.value1},"from":"zhibotv"}`;
        }
      } else if (this.$route.name === "atlas-id") {
        location.href = `zhibotv://www.zhibo.tv:80/android?json={"code":"${this.code}","value1":${this.value1},"value2":"${this.title}","from":"zhibotv"}`;
      } else {
        location.href = `zhibotv://www.zhibo.tv:80/android?json={"code":"${this.code}","value1":${this.value1},"from":"zhibotv"}`;
      }
      setTimeout(() => {
        this.downApply();
      }, 1000);
    },
    downApply() {
      const ua = navigator.userAgent;
      const isAndroid = ua.includes("Android") || ua.includes("Linux");
      const isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
      const isWeixin = ua.indexOf("MicroMessenger") > 0; // 是否微信
      if (isWeixin) {
        window.location.href =
          "https://android.myapp.com/myapp/detail.htm?apkName=com.seca.live&ADTAG=mobile";
      } else if (isAndroid) {
        // window.open('https://android.myapp.com/myapp/detail.htm?apkName=com.seca.live&ADTAG=mobile')
        window.location.href =
          "https://android.myapp.com/myapp/detail.htm?apkName=com.seca.live&ADTAG=mobile";
      } else if (isIOS) {
        // window.open('https://apps.apple.com/cn/app/zhi-botv-feng-ge-jiong-yi/id1064012897')
        window.location.href =
          "https://apps.apple.com/cn/app/zhi-botv-feng-ge-jiong-yi/id1064012897";
      }
    },
    // 分享好友
    toShare() {
      this.gotodown();
    },
    // 取用户信息，获取房间号
    async getUserinfo() {
      axios.defaults.withCredentials = true;
      const res = await this.$api.getLoginInfo();
      axios.defaults.withCredentials = false;
      // .then((res) => {
      if (res.data.data.userToken) {
        this.gain = res.data.data.roomNum;
      } else {
        this.gain = "";
      }
    },
    shareInfo2() {
      this.shareUrl =
        this.$address +
        "static.zhibo.tv/specialtopic/shareoguess?gain=" +
        this.gain +
        "&configId=" +
        this.configId;
      this.shareImg = "https://images.zhibo.tv/2021/0713/guessshare.png";
      this.shareTitle = "参与奥运竞猜 每日瓜分10万播币";
      this.shareParams = {
        title: this.shareTitle,
        imageUrl: this.shareImg,
        jumpUrl: this.shareUrl,
      };
      this.gotoAPPShare();
    },
    // 调用两端分享
    gotoAPPShare() {
      // 两端的分享方法
      try {
        window.webkit.messageHandlers.share.postMessage(this.shareParams);
      } catch (e) {
        window.console.log("ios调用分享失败2", this.shareParams);
      }
      try {
        window.LiveAppJS.share(this.shareTitle, this.shareImg, this.shareUrl);
      } catch (e) {
        window.console.log(
          "Android调用分享失败2",
          this.shareTitle,
          this.shareImg,
          this.shareUrl
        );
      }
    },
    closeBtn() {
      if (this.betInfo === true && this.type === 1) {
        // this.maskShow = true
        this.betInfo = false;
        this.betLog = true;
      } else {
        this.maskShow = false;
        this.betInfo = false;
        this.betLog = false;
        this.topBet = false;
        this.rule = false;
      }
    },
    // 查看全部
    lookMore(name, index, type, betitem) {
      this.type = type;
      this.maskShow = true;
      if (name === "rule") {
        this.answer_message = "活动说明";
        this.rule = true;
      }
      if (name === "betInfo" && betitem) {
        // 竞猜详情
        this.answer_message = "竞猜详情";
        this.betitem = betitem;
        this.betInfo = true;
      }
    },
    //  竞猜信息
    async getOlympicGuess() {
      let params = {
        user_id: this.token ? this.token.split("*")[1] : "",
      };

      let res = await this.$api.getOlympicGuess(params);
      this.guesslist = res.data.data.guess_list;

      this.guesslist = this.guesslist.sort((a, b) => {
        return a.start_time - b.start_time;
      });

      window.console.log(this.guesslist);
      // 我得竞猜
      this.myGuess = res.data.data.my_guess_list;
      // 助力信息
      if (res.data.data.help_list.list) {
        this.powerList = res.data.data.help_list.list;
        this.powerNum = res.data.data.help_list.num;
      }
      for (var i = 0; i < this.guesslist.length; i++) {
        this.isanswer[i] = -1;
      }
      //当前正在进行的竞猜item
      var item = this.guesslist.filter((item) => item.is_start == "0");
      var index = this.guesslist.findIndex((item) => item.is_start == "0");
      // 今天的竞猜
      var toadyitem = this.guesslist.filter(
        (item) =>
          parseInt(parseInt(item.start_time) * 1000) >= this.startT &&
          parseInt(parseInt(item.start_time) * 1000) <= this.endT
      );
      var todayindex = this.guesslist.findIndex(
        (item) =>
          parseInt(parseInt(item.start_time) * 1000) >= this.startT &&
          parseInt(parseInt(item.start_time) * 1000) <= this.endT
      );

      // 今天的下一天的竞猜
      var newitem = this.guesslist.filter(
        (item) => parseInt(parseInt(item.start_time) * 1000) > this.endT
      );
      var newindex = this.guesslist.findIndex(
        (item) => parseInt(parseInt(item.start_time) * 1000) > this.endT
      );

      // window.console.log(parseInt(parseInt(this.guesslist[2].start_time)*1000))
      // 有正在进行的竞猜
      if (item.length > 0) {
        this.isactive = index;
        this.currentGuess = item[0];
        this.optionId = this.currentGuess.teams[0].id;
        window.console.log(this.currentGuess, index, "a");
        // 没有正在进行的显示 今天的竞猜
      } else if (toadyitem.length > 0) {
        this.isactive = todayindex;
        this.currentGuess = toadyitem[0];
        this.optionId = this.currentGuess.teams[0].id;
        window.console.log(this.currentGuess, "b");
        // 显示下一天的竞猜
      } else if (newindex > -1) {
        // this.currentGuess = this.guesslist[0]
        // this.optionId = this.currentGuess.teams[0].id
        this.isactive = newindex;
        this.currentGuess = newitem[0];
        this.optionId = this.currentGuess.teams[0].id;
        window.console.log(this.currentGuess, "c");
        // 明天没有竞猜
      } else {
        this.currentGuess = this.guesslist[0];
        this.optionId = this.currentGuess.teams[0].id;
      }
      window.console.log(this.isactive, 214 * parseInt(this.isactive - 1));
      this.$nextTick(() => {
        window.console.log(this.$refs.newtabs, 214 * parseInt(this.isactive));
        var itemwidth = this.$refs.tabitem[0].clientWidth;
        window.console.log(itemwidth);
        if (this.isactive >= 1) {
          this.$refs.newtabs.scrollTo({
            left: parseInt(itemwidth * parseInt(this.isactive - 1)),
          });
        } else {
          this.$refs.newtabs.scrollTo({
            left: parseInt(itemwidth * parseInt(this.isactive)),
          });
        }
      });
      // if(document.querySelector("#a2")){
      //   this.$refs.newtabs.scrollTo(214,0)
      // }
      if (this.token) {
        // 获取分享信息
        this.getOlympicShare();
      }
      if (this.myGuess.length > 0) {
        this.myGuess = this.myGuess.reverse();
      }
      let res2 = await this.$api.getOlympicGuessRule();
      this.rules = res2.data.data.content;
      this.rules = this.rules.replace(/style="\/?.+?"/g, "").replace(/ /g, "");
      this.rules = this.rules
        .replace(/<br\s*\/?>/g, "<div></div>")
        .replace(/ /g, "");
      window.console.log(this.rules);
    },
    // 已经登录的用户信息 竞猜信息 获取竞猜分享信息头像
    async getOlympicShare() {
      let params = {};
      params = {
        user_id: this.token ? this.token.split("*")[1] : "",
        guess_id: this.currentGuess.id,
      };
      let res = await this.$api.getOlympicGuess(params);
      window.console.log(res);
      this.guesslist = res.data.data.guess_list;
      this.guesslist = this.guesslist.sort((a, b) => {
        return a.start_time - b.start_time;
      });
      // 我得竞猜
      this.myGuess = res.data.data.my_guess_list;
      // 助力信息
      if (res.data.data.help_list.list) {
        this.powerList = res.data.data.help_list.list;
        this.powerNum = res.data.data.help_list.num;
      }
      this.currentGuess = res.data.data.guess_list[this.isactive];
      if (this.myGuess.length > 0) {
        this.myGuess = this.myGuess.reverse();
        for (var j = 0; j < this.myGuess.length; j++) {
          this.overGuessId.push(this.myGuess[j].guess_id);
        }
      }
      for (var k = 0; k < this.guesslist.length; k++) {
        // 1已经竞猜过，0未参与
        if (this.guesslist[k].is_guess) {
          if (this.guesslist[k].is_guess && this.guesslist[k].is_guess == 1) {
            this.overGuessId.push(this.guesslist[k].id);
          }
        }
      }
    },
    // 提交竞猜
    async getGuessUser() {
      // this.teamIds = this.tindexList[this.stab].toString();
      let params = {
        user_id: this.token ? this.token.split("*")[1] : "",
        guess_id: this.currentGuess.id, //题目id
        guess_option: this.optionId, // 选项id
      };
      // window.console.log(this.tindexList[this.stab],this.stab)
      window.console.log(params);
      let res = await this.$api.getOlympicGuessAnswer(params);
      if (res.data.control.status == "200") {
        Toast("提交成功");
        setTimeout(() => {
          this.getOlympicGuess();
        }, 5000);
      } else {
        Toast("提交失败，请稍后再试");
      }
    },
    // 用户竞猜操作
    async answerSubmit() {
      this.gotodown();
    },
  },
};
</script>

<style scoped lang="less">
@font-face {
  font-family: YouSheBiaoTiHei-3;
  src: url("https://images.zhibo.tv/fonts/YouSheBiaoTiHei-3.ttf");
  font-weight: normal;
  font-style: normal;
}
.content {
  width: 100%;
  .tabsbg {
    width: 0.54rem;
    height: 0.72rem;
    display: block;
  }
  .tabs {
    width: 6.42rem;
    display: flex;
    overflow: auto;
    justify-content: flex-start;
    .tabitem {
      width: 2.14rem;
      height: 0.72rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url("https://images.zhibo.tv/2021/0713/noselect.png") center
        no-repeat;
      background-size: 100% 100%;
      flex-shrink: 0;
      font-size: 0.3rem;
      font-family: YouSheBiaoTiHei-3;
      font-weight: normal;
      color: rgba(255, 255, 255, 0.6);
    }
    .tabitem_select {
      background: url("https://images.zhibo.tv/2021/0713/selected.png") center
        no-repeat;
      color: #ff9fa6;
      background-size: 100% 100%;
      text-shadow: 0px 1px 0px #000000;
    }
  }
  .tabsnew {
    justify-content: space-around;
  }
  .module {
    .shareimg {
      width: 2.14rem;
      height: 0.72rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url("https://images.zhibo.tv/2021/0713/selected.png") center
        no-repeat;
      background-size: 100% 100%;
      flex-shrink: 0;
      font-size: 0.3rem;
      font-family: YouSheBiaoTiHei-3;
      font-weight: normal;
      color: #ff9fa6;
      text-shadow: 0px 1px 0px #000000;
    }
  }

  .answer {
    width: 100%;
    height: 9.7rem;
    background: url("https://images.zhibo.tv/2021/0713/answerbg.png") center
      no-repeat;
    background-size: 100% 100%;
    // border-radius: 20px;
    margin: 0.43rem auto 0;
    .answer_title {
      width: 5.16rem;
      height: 1.32rem;
      display: flex;
      justify-content: center;
      align-items: center;
      // height: 1.32px;
      font-size: 0.42rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 0.66rem;
      padding-top: 1.37rem;
      padding-left: 1.24rem;
      text-align: center;
    }
    .answer_options {
      width: 4.84rem;
      height: 3.82rem;
      margin: 0.66rem auto 0;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      // margin: 0 auto;
      .answer_option {
        width: 4.84rem;
        height: 0.88rem;
        font-size: 0.34rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.1rem;
        padding-bottom: 0.04rem;
        box-sizing: border-box;
        img {
          width: 0.78rem;
          height: 0.45rem;
          display: block;
          margin-right: 0.2rem;
          object-fit: contain;
        }
        .option {
          position: relative;
          img {
            position: absolute;
            left: -0.98rem;
            top: 0.05rem;
          }
        }
      }
      .answerSelect {
        background: url("https://images.zhibo.tv/2021/0713/selected_bg.png")
          center no-repeat;
        background-size: 100% 100%;
      }
    }
    .answer_submit {
      width: 4.38rem;
      height: 1.06rem;
      display: block;
      margin: 0.28rem auto 0;
    }
  }
}
.logo {
  width: 100%;
  height: 1.94rem;
  box-sizing: border-box;
  .logoimg {
    width: 0.52rem;
    height: 0.58rem;
    display: block;
    margin: 1.2rem auto 0;
  }
}
img {
  object-fit: cover;
}
.EuropeanCup {
  background: #001e66;
  // padding-bottom: 2.68rem;
}
.EuropeanCup .banner {
  height: 6.8rem;
  position: relative;
  background: url("https://images.zhibo.tv/2021/0713/banner.png") center
    no-repeat;
  background-size: 100% 100%;
  margin-top: 1rem;
}
.EuropeanCup .banner .rule-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 0.35rem;
  width: 1.64rem;
  height: 0.64rem;
  background: url("https://images.zhibo.tv/2021/0609/icon_rule.png") center
    no-repeat;
  background-size: contain;
  cursor: pointer;
}
.EuropeanCup .content {
  // background: url();
}
.EuropeanCup .select-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 0.72rem;
  // background: url(https://images.zhibo.tv/2021/0607/topbg.png) top center
  // no-repeat;
  // background-size: contain;
}

.EuropeanCup .select-tab img {
  max-height: 0.72rem;
}
.EuropeanCup .select-tab .top {
  flex: 1;
  max-width: 2.14rem;
  height: 0.72rem;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% 100%;
  cursor: pointer;
}
.EuropeanCup .select-tab .top8 {
  background-image: url(https://images.zhibo.tv/2021/0607/top8.png);
}
.EuropeanCup .select-tab .top8.picked {
  background-image: url(https://images.zhibo.tv/2021/0607/top8a.png);
}
.EuropeanCup .select-tab .top4 {
  background-image: url(https://images.zhibo.tv/2021/0607/top4.png);
}
.EuropeanCup .select-tab .top4.picked {
  background-image: url(https://images.zhibo.tv/2021/0607/top4a.png);
}
.EuropeanCup .select-tab .top1 {
  background-image: url(https://images.zhibo.tv/2021/0607/top1.png);
}
.EuropeanCup .select-tab .top1.picked {
  background-image: url(https://images.zhibo.tv/2021/0607/top1a.png);
}
.EuropeanCup .select-area {
  position: relative;
  width: 7.18rem;
  margin: 0.36rem auto 0;
  z-index: 1;
}
.EuropeanCup .select-area::before {
  content: "";
  display: block;
  position: absolute;
  top: 0.08rem;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #213371 0%, #0e1a45 100%);
  border-radius: 0.1rem;
  z-index: -1;
}
.EuropeanCup .team-list {
  padding: 0.02rem 0.11rem 0;
}
.EuropeanCup .team-list ul {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 0.1rem;
  &.end li {
    opacity: 0.4;
  }
}
.EuropeanCup .team-list ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 0.44rem;
  flex-basis: 1.56rem;
  height: 2.08rem;
}
.EuropeanCup .team-list2 ul {
  justify-content: center;
}
.EuropeanCup .team-list2 ul li:nth-of-type(2n-1) {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 0.44rem;
  flex-basis: 1.56rem;
  height: 2.08rem;
  margin-right: 1.54rem;
}
.EuropeanCup .team-list ul li .teamLogo {
  width: 1.04rem;
  height: 1.04rem;
  overflow: hidden;
  border-radius: 50%;
  border: 0.03rem solid #fff;
}
.EuropeanCup .team-list ul li.pick {
  background: url(https://images.zhibo.tv/2021/0607/team-select.png) top center
    no-repeat;
  background-size: contain;
  opacity: 1;
}
.EuropeanCup .team-list ul.end li.pick {
  background: none;
}
.EuropeanCup .team-list ul li.pick .teamLogo {
  border-color: #73e9ff;
}
.EuropeanCup .team-list ul li.pick .teamName {
  color: #73e9ff;
}
.EuropeanCup .team-list ul li .teamName {
  margin-top: 0.12rem;
  font-size: 0.28rem;
  line-height: 0.4rem;
  color: #ddd;
  text-align: center;
}

.EuropeanCup .select-area .guess-name {
  position: relative;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(https://images.zhibo.tv/2021/0607/guess_name_bg.png) top
    center no-repeat;
  width: 4.6rem;
  height: 0.8rem;
  font-size: 0.32rem;
  color: #73e9ff;
  font-weight: 500;
  background-size: contain;
}
.EuropeanCup .select-area .endTime {
  margin-top: 0.16rem;
  font-size: 0.24rem;
  line-height: 0.32rem;
  color: #9aefff;
  text-align: center;
  opacity: 0.6;
}
.EuropeanCup .select-area .bets {
  padding: 1.02rem 0.25rem 0;
}
.EuropeanCup .select-area .bets .capital {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #73e9ff;
  font-size: 0.24rem;
  line-height: 0.32rem;
}
.EuropeanCup .select-area .bets .capital p {
  opacity: 0.7;
}
.EuropeanCup .select-area .bets .capital p:nth-child(2) {
  flex: 1;
  padding-left: 0.4rem;
}
.EuropeanCup .select-area .bets .capital span {
  display: flex;
  align-items: center;
  color: rgba(115, 233, 235, 0.9);
}
.EuropeanCup .select-area .bets .capital span i {
  padding-left: 0.08rem;
  font-style: normal;
  color: rgba(115, 233, 235, 0.7);
}
.EuropeanCup .select-area .bets .bets-layer {
  position: relative;
  margin-top: 0.24rem;
  width: 100%;
  height: 2.62rem;
  padding: 0.32rem;
  box-sizing: border-box;
  background: linear-gradient(180deg, #213371 0%, #0e1a45 100%);
  border-radius: 0.1rem;
}
.EuropeanCup .select-area .bets .bets-layer .betNum {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.EuropeanCup .select-area .bets .bets-layer .betNum p {
  font-size: 0.32rem;
  color: #73e9ff;
  line-height: 0.44rem;
  flex: 1;
}
.EuropeanCup .select-area .bets .bets-layer .betNum > div {
  display: flex;
  align-items: center;
}
.EuropeanCup .select-area .bets .bets-layer input {
  margin: 0 0.16rem;
  width: 1rem;
  height: 0.64rem;
  border-radius: 0.1rem;
  background: #0f1c4a;
  font-size: 0.28rem;
  line-height: 0.64rem;
  color: #73e9ff;
  font-weight: 500;
  text-align: center;
}

.EuropeanCup .select-area .bets .bets-layer .plus,
.EuropeanCup .select-area .bets .bets-layer .minus {
  width: 0.32rem;
  height: 0.32rem;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: contain;
}
.EuropeanCup .select-area .bets .bets-layer .plus {
  background-image: url(https://images.zhibo.tv/2021/0607/icon_plus.png);
}
.EuropeanCup .select-area .bets .bets-layer .minus {
  background-image: url(https://images.zhibo.tv/2021/0607/icon_minus.png);
}
.EuropeanCup .select-area .bets .bets-layer .cant {
  opacity: 0.6;
}
.EuropeanCup .select-area .bets .bets-layer .prompt {
  margin-top: -0.02rem;
  font-size: 0.24rem;
  line-height: 0.32rem;
  opacity: 0.4;
  color: #73e9ff;
}
.EuropeanCup .select-area .bets .bets-layer .submit-btn {
  position: absolute;
  left: 50%;
  margin-left: -2.19rem;
  bottom: -0.12rem;
  width: 4.38rem;
  height: 1.06rem;
  background: url(https://images.zhibo.tv/2021/0607/btn_submit.png) top center
    no-repeat;
  background-size: contain;
}
.EuropeanCup .module.share {
  margin-top: 1.2rem;
  padding-bottom: 1.04rem;
}
.EuropeanCup .module {
  position: relative;
  margin: 0 0.4rem;
  background: url(https://images.zhibo.tv/2021/0713/answerbg2.png) top center
    no-repeat;
  background-size: 100%;
  // background: linear-gradient(180deg, #213371 0%, #0e1a45 100%);
  // background: linear-gradient(360deg, #0F50CA 0%, rgba(14, 70, 175, 0) 40%, rgba(13, 67, 168, 0) 72%, rgba(15, 80, 202, 0.72) 100%);
  border-radius: 0.1rem;
}
.EuropeanCup .module h3 {
  position: absolute;
  margin-top: -0.36rem;
  margin-left: -0.2rem;
  width: 2.17rem;
}

.EuropeanCup .module .share-module {
  padding-top: 0.32rem;
}
.EuropeanCup .module .share-module > div:first-child {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.EuropeanCup .module .share-module figure {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 0.16rem;
  width: 3.8rem;
  height: 2.72rem;
  img {
    width: 3.8rem;
    height: 2.72rem;
    display: block;
  }
}
.EuropeanCup .module .share-module p {
  color: #73e9ff;
  font-size: 0.24rem;
  line-height: 0.32rem;
  text-align: center;
}

.EuropeanCup .module .share-module .sharestats {
  position: relative;
  margin: 0.3rem auto 0;
  width: 5.5rem;
  padding-bottom: 0.72rem;
  padding-top: 0.46rem;
  max-height: 2.42rem;
  background: rgba(37, 59, 131, 0.5);
  border-radius: 0.1rem;
  .powerimg {
    width: 100%;
    height: 100%;
    display: block;
  }
}
.EuropeanCup .module .share-module .share-btn {
  position: absolute;
  left: 50%;
  bottom: -0.58rem;
  margin-left: -2.19rem;
  width: 4.38rem;
  height: 1.06rem;
  background: url(https://images.zhibo.tv/2021/0607/btn_share.png) top center
    no-repeat;
  background-size: contain;
}

.EuropeanCup .module .share-module .sharestats > p {
  margin-bottom: 0.12rem;
  padding-top: 0.3rem;
  font-size: 0.24rem;
  color: #ffc16d;
  line-height: 0.32rem;
}
.EuropeanCup .module .share-module .sharestats span {
  display: block;
  font-size: 0.22rem;
  color: #73e9ff;
  line-height: 0.28rem;
  text-align: center;
  opacity: 0.8;
  transform: scale(0.91668);
}
.EuropeanCup .module .share-module .sharestats > div p {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.2rem;
}
.EuropeanCup .module .share-module .sharestats > div p i {
  margin: 0 0.06rem;
  width: 0.48rem;
  height: 0.48rem;
  border-radius: 50%;
  border: 1px solid #73e9ff;
  overflow: hidden;
  box-sizing: border-box;
}
.EuropeanCup .module.mybet {
  margin-top: 1.6rem;
  background: linear-gradient(
    360deg,
    #0f50ca 0%,
    rgba(14, 70, 175, 0) 40%,
    rgba(13, 67, 168, 0) 72%,
    rgba(15, 80, 202, 0.72) 100%
  );
}
.EuropeanCup .module .mybetlog {
  position: relative;
  padding-top: 0.64rem;
  margin: 0 0.3rem;
  min-height: 3.02rem;
  box-sizing: border-box;
}
.EuropeanCup .module .mybetlog p {
  display: flex;
  align-items: center;
  color: #73e9ff;
  font-size: 0.24rem;
  line-height: 0.32rem;
  padding-bottom: 0.28rem;
}
.EuropeanCup .module .mybetlog p.caption {
  font-size: 0.24rem;
  color: #fff;
  opacity: 0.6;
}
.EuropeanCup .module .mybetlog .time {
  width: 2.6rem;
}
.EuropeanCup .module .mybetlog .score {
  width: 2.6rem;
}
.EuropeanCup .module .mybetlog p:not(:first-child) .time,
.EuropeanCup .module .mybetlog p:not(:first-child) .score {
  opacity: 0.8;
}
.EuropeanCup .module .mybetlog .top {
  width: 1.12rem;
}
.EuropeanCup .module .mybetlog .name {
  width: 2.64rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.EuropeanCup .module .mybetlog .noData {
  font-size: 0.24rem;
  line-height: 0.32rem;
  padding-top: 0.44rem;
  color: #73e9ff;
  text-align: center;
  opacity: 0.6;
}
.EuropeanCup .module .mybetlog .more {
  position: absolute;
  right: 0;
  bottom: 0;
  text-align: right;
  color: rgba(115, 233, 235, 0.6);
  font-size: 0.24rem;
  line-height: 0.32rem;
}

.EuropeanCup .module.topbet {
  margin-top: 1.32rem;
  background: linear-gradient(
    360deg,
    #0f50ca 0%,
    rgba(14, 70, 175, 0) 40%,
    rgba(13, 67, 168, 0) 72%,
    rgba(15, 80, 202, 0.72) 100%
  );
}
.EuropeanCup .module.topbet .mybetlog span:last-child {
  padding-left: 0.8rem;
  white-space: nowrap;
}
.EuropeanCup .module.topbet p:not(:first-child) .name,
.EuropeanCup .module.topbet p:not(:first-child) span:last-child {
  opacity: 0.8;
}
.EuropeanCup .module.topbet p:not(:first-child) span.top {
  color: #ffb95b;
  opacity: 1;
}
.EuropeanCup .mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: rgba(0, 0, 0, 0.3);
}
.EuropeanCup .mask-layer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.EuropeanCup .mask-layer .mask-content {
  position: relative;
  width: 6.2rem;
  background: #083998;
  border-radius: 0.1rem;
}
.EuropeanCup .mask-layer .mask-title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.34rem;
  line-height: 0.44rem;
  color: #73e9ff;
  font-weight: 500;
  height: 1.16rem;
}
.EuropeanCup .mask-layer .close {
  position: absolute;
  width: 0.32rem;
  height: 0.32rem;
  top: 0.32rem;
  right: 0.32rem;
  background: url(https://images.zhibo.tv/2021/0609/icon_close.png) top center
    no-repeat;
  background-size: contain;
  cursor: pointer;
}
.EuropeanCup .mask-layer .close-btn {
  position: absolute;
  left: 50%;
  margin-left: -1.69rem;
  bottom: -0.56rem;
  width: 3.38rem;
  height: 1.06rem;
  cursor: pointer;
  background: url(https://images.zhibo.tv/2021/0607/btn_close.png) top center
    no-repeat;
  background-size: contain;
}
.EuropeanCup .mask-layer .rule {
  padding: 0.28rem 0.4rem 0;
  height: 6.4rem;
  margin-bottom: 0.84rem;
  box-sizing: border-box;
  overflow: auto;
  box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.1),
    0px 1px 0px 0px rgba(255, 255, 255, 0.1);
}
.EuropeanCup .mask-layer .rule /deep/ h3 {
  // padding-bottom: 0.2rem;
  opacity: 0.9;
  font-size: 0.28rem;
  color: #fff;
  line-height: 0.4rem;
}
.EuropeanCup .mask-layer .rule h4 {
  padding-bottom: 0.2rem;
  font-size: 0.26rem;
  line-height: 0.37rem;
  opacity: 0.9;
  color: #fff;
}
.EuropeanCup .mask-layer .rule /deep/ p {
  // padding-bottom: 0.2rem;
  font-size: 0.24rem;
  color: rgba(255, 255, 255, 0.6);
  line-height: 0.33rem;
}
.EuropeanCup .mask-layer .rule /deep/ div {
  height: 0.2rem;
}
.EuropeanCup .mask-layer .rule /deep/ span {
  padding-bottom: 0.2rem;
  opacity: 0.9;
  font-size: 0.28rem;
  color: #fff !important;
  line-height: 0.4rem;
}

.EuropeanCup .mask-layer .betInfo {
  height: 4.02rem;
  padding: 0.32rem 0.4rem 0;
  box-sizing: border-box;
  margin-bottom: 0.84rem;
  box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.1);
}
.EuropeanCup .mask-layer .betInfo p {
  display: flex;
  align-items: flex-start;
  font-size: 0.24rem;
  padding-bottom: 0.4rem;
  line-height: 0.32rem;
  color: rgba(255, 255, 255, 0.6);
}
.EuropeanCup .mask-layer .betInfo p span {
  flex: 1;
  color: #fff;
}

.EuropeanCup .mask-layer .betLog {
}
.EuropeanCup .mask-layer .betLog .caption {
  display: flex;
  align-items: center;
  height: 0.4rem;
  padding: 0 0.4rem 0.08rem;
  font-size: 0.24rem;
  color: #fff;
}
.EuropeanCup .mask-layer .betLog ul {
  margin-bottom: 0.84rem;
  height: 6rem;
  padding: 0.28rem 0.4rem 0;
  box-sizing: border-box;
  box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.1),
    0px 1px 0px 0px rgba(255, 255, 255, 0.1);
  overflow: auto;
}
.EuropeanCup .mask-layer .betLog ul li {
  display: flex;
  align-items: center;
  padding-bottom: 0.32rem;
  font-size: 0.24rem;
  line-height: 0.32rem;
  color: rgba(255, 255, 255, 0.8);
}
.EuropeanCup .mask-layer .betLog .time {
  width: 2.64rem;
  padding-right: 0.12rem;
}
.EuropeanCup .mask-layer .betLog .num {
  width: 1.84rem;
  margin-left: 0.12rem;
}
.EuropeanCup .mask-layer .betLog ul li span:last-child {
  color: #73e9ff;
  white-space: nowrap;
}

.EuropeanCup .mask-layer .topBet {
}
.EuropeanCup .mask-layer .topBet .caption {
  display: flex;
  align-items: center;
  height: 0.4rem;
  padding: 0 0.4rem 0.08rem;
  font-size: 0.24rem;
  color: #fff;
  white-space: nowrap;
}
.EuropeanCup .mask-layer .topBet ul {
  margin-bottom: 0.84rem;
  height: 6rem;
  padding: 0.28rem 0.4rem 0;
  box-sizing: border-box;
  box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.1),
    0px 1px 0px 0px rgba(255, 255, 255, 0.1);
  overflow: auto;
}
.EuropeanCup .mask-layer .topBet ul li {
  display: flex;
  align-items: center;
  padding-bottom: 0.32rem;
  font-size: 0.24rem;
  line-height: 0.32rem;
  color: rgba(255, 255, 255, 0.8);
}
.EuropeanCup .mask-layer .topBet .top {
  width: 1.12rem;
}
.EuropeanCup .mask-layer .topBet .name {
  width: 2.46rem;
  margin-right: 0.48rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.EuropeanCup .mask-layer .topBet ul li span:last-child {
  color: #73e9ff;
  white-space: nowrap;
}
.EuropeanCup .mask-layer .topBet ul li:nth-of-type(n + 4) span {
  color: rgba(255, 255, 255, 0.6);
  line-height: 0.32rem;
}
.EuropeanCup .mask-layer .topBet ul li:nth-of-type(-n + 3) span {
  color: #73e9ff;
}
.EuropeanCup .mask-layer .topBet ul li:nth-of-type(-n + 3) .top {
  color: #ffb95b;
}
.EuropeanCup .mask-layer .noData {
  font-size: 0.24rem;
  padding-top: 0.48rem;
  color: #73e9ff;
  text-align: center;
  opacity: 0.6;
}
.EuropeanCup .share-box {
  // display: ;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 3;
}
.EuropeanCup .share-user-info {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.EuropeanCup .share-box .user-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.EuropeanCup .share-box .user-info > div:first-of-type {
  position: relative;
  width: 6.06rem;
  height: 4.1rem;
  border-radius: 0.12rem;
  background: #083998;
  box-shadow: 0px 0px 0.12rem 0px rgba(39, 140, 255, 0);
  border-radius: 0.12rem;
  border: 0.1rem solid rgba(30, 72, 173, 0.5);
}
.EuropeanCup .share-box .user-info > div:first-of-type:after {
  content: "";
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
  bottom: 0.1rem;
  left: 0.1rem;
  z-index: -1;
  background: linear-gradient(134deg, #425bc0 0%, #2b3f86 100%);
  border-radius: 0.1rem;
}
.EuropeanCup .share-box .user-info .user-head {
  margin: -0.7rem auto 0;
  width: 1.2rem;
  height: 1.2rem;
  box-shadow: 0px 0.06rem 0.26rem 0px rgba(10, 20, 51, 0.1);
  border: 0.04rem solid #fff;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  img {
    width: 1.2rem;
    height: 1.2rem;
    display: block;
  }
}
.user-close {
  position: absolute;
  top: 0.2rem;
  right: 0.2rem;
  width: 0.24rem;
  height: 0.24rem;
  background: url(https://images.zhibo.tv/2021/0621/userClose2.png) center
    center no-repeat;
  background-size: 100%;
  display: none;
}
// .user-info::after{
//   content: "";
//     width: .72rem;
//   height: .72rem;
//   position: absolute;
//   top: 7.61rem;
//   background: url(https://images.zhibo.tv/2021/0621/userClose.png) center center no-repeat;
//   background-color: rgba(87, 88, 89, 0.33);
//   background-size: .32rem .32rem;
//   border-radius: 50%;
// }
.user-close2 {
  width: 0.72rem;
  height: 0.72rem;
  background: rgba(87, 88, 89, 0.33);
  border-radius: 50%;
  margin-top: 2.11rem;
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;
  img {
    width: 0.32rem;
    height: 0.32rem;
    display: block;
  }
}
.EuropeanCup .share-box .user-info .user-name {
  margin-top: 0.16rem;
  margin-bottom: 0.32rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #73e9ff;
  font-size: 0.24rem;
  line-height: 0.32rem;
  text-align: center;
  letter-spacing: -0.0058rem;
}
.EuropeanCup .share-box .share-text {
  position: relative;
  display: flex;
  align-items: center;
  // justify-content: center;
  flex-direction: column;
  border-radius: 0.04rem;
  margin: 0 0.24rem;
  height: 2.46rem;
  background: #fff;
  font-size: 0.26rem;
  color: #25356c;
  line-height: 0.4rem;
  text-align: center;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  padding-top: 0.44rem;
  box-sizing: border-box;
}
.EuropeanCup .share-box .share-text p {
  // padding-bottom: 0rem;
  // margin-bottom: .08rem;
  // margin-top: 0;
  letter-spacing: -0.0063rem;
}
.EuropeanCup .share-box .share-text .p1 {
  // padding-bottom: 0rem;
  margin-bottom: 0.24rem;
}
.EuropeanCup .share-box .share-text .p2 {
  // padding-bottom: 0rem;
  margin-top: 0.21rem;
}
.EuropeanCup .share-box .share-text p:last-of-type {
  // padding-bottom: 0;
  // margin-bottom: 0;
  // margin-top: .08rem;
}
.EuropeanCup .share-box .share-text img {
  width: 0.34rem;
}
.EuropeanCup .share-box .share-text .mid {
  width: 4.04rem;
}
.EuropeanCup .share-box .share-text .sup {
  position: absolute;
  top: 0.2rem;
  left: 0.2rem;
}
.EuropeanCup .share-box .share-text .sub {
  position: absolute;
  right: 0.2rem;
  bottom: 0.2rem;
}
.EuropeanCup .share-box .help-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.34rem;
  width: 6.06rem;
  height: 0.96rem;
  background: url("https://images.zhibo.tv/2021/0713/helpbtn.png") center
    no-repeat;
  background-size: 100% 100%;
  border-radius: 0.48rem;
  font-size: 0.32rem;
  font-weight: 600;
  color: #fff;
  text-shadow: 0px 1px 0.06rem rgba(169, 98, 42, 0.5);
}
.EuropeanCup .share-box .help-btn.done {
  background: url("https://images.zhibo.tv/2021/0713/helpdone.png") center
    no-repeat;
  background-size: 100% 100%;
  color: #fff;
  text-shadow: none;
}
@media (-webkit-min-device-pixel-ratio: 1.5) and (-webkit-max-device-pixel-ratio: 2.5) {
}
@media (-webkit-min-device-pixel-ratio: 2.5) {
}
@supports (bottom: env(safe-area-inset-bottom)) {
  .m750 {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    background: #0e1a45;
  }
}
</style>
